import { Injectable, EventEmitter } from '@angular/core'

@Injectable()
export class LoaderService {
  showEvent = new EventEmitter()
  hideEvent = new EventEmitter()
  setTextEvent = new EventEmitter()
  callsCount = 0

  show(text?: string) {
    this.callsCount++

    setTimeout(() => {
      if (this.callsCount >= 1) {
        this.showEvent.next(null)
      }
    }, 400)

    this.setText(text)
  }

  setText(text?: string) {
    this.setTextEvent.next(text)
  }

  hide() {
    this.callsCount--

    if (this.callsCount <= 0) {
      this.hideEvent.next(null)
    }
  }

  hideNow() {
    this.hideEvent.next(null)
  }
}
